module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.98 21.97\"><title>arrow</title><g id=\"Page-1\"><g id=\"Landing\"><g id=\"arrow\"><g id=\"Group-5\"><polygon id=\"Fill-3\" points=\"0 0 17.49 21.97 34.98 0 27.08 0 20.92 7.7 17.49 12.18 14.06 7.7 7.9 0 0 0\"></polygon></g></g></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 500
// module chunks = 1